export enum SortingState {
    Down,
    Up,
    NotSorted
}